import clsx from 'clsx';
import useLayout from 'hooks/useLayout';
import {FC, ReactNode, useRef} from 'react';

export type FormActionsProps = {
    align?: 'left' | 'right';
    children: ReactNode;
    className?: string;
    spacing?: 'sm';
};

const FormActions: FC<FormActionsProps> = ({
    align = 'right',
    children,
    className,
    spacing,
}) => {
    const ref = useRef(null);
    const layout = useLayout(ref);

    if (!layout) return <div className="hidden" ref={ref} />;

    return (
        <>
            {layout === 'sideBySide' && (
                <div aria-label="spacer" ref={ref} role="gridcell">
                    &nbsp;
                </div>
            )}
            <div
                className={clsx(
                    'flex',
                    spacing === 'sm' ? 'gap-4' : 'gap-6',
                    align === 'right' ? 'justify-end' : 'pl-0.5',
                    className,
                )}
                role={layout === 'sideBySide' ? 'gridcell' : undefined}
            >
                {children}
            </div>
        </>
    );
};

export default FormActions;
